import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const policyListDateSlice = createApi({
    reducerPath: "policyListDate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://policy-parsing.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        policyListDate: builder.query({
            query: (data) => ({ url: "/policy-inward/api/v1/policy/list", params: data, method: "GET" }),
        }),
    }),
});

export const { usePolicyListDateQuery } = policyListDateSlice;
